import { GUEST } from '../constants/cardTypeConstants';

const mapPersonaBenefits = (object, iaCode) => Object.values(object)
  .filter((benefitItem) => {
    if (Object.keys(benefitItem).length === 0) {
      return false;
    }

    const {
      iconClass,
      heading,
      bodyText,
    } = benefitItem;

    return iconClass && heading && bodyText;
  })
  .map((item) => ({
    ...item,
    icon: item.iconClass,
    analyticElement: `hp-benefits-${iaCode}-${item.heading?.replace(' ', '-')}`,
  }));

const mapPersonaData = (object) => Object.values(object)
  .filter((personaItem) => {
    if (Object.keys(personaItem).length === 0) {
      return false;
    }

    const {
      heading,
      bodyText,
      ctaLabel,
      redirectUrl,
      analyticElement,
    } = personaItem;

    return heading
      && bodyText
      && ctaLabel
      && redirectUrl
      && analyticElement;
  })
  .map((item) => ({
    ...item,
    enabled: true,
    imageLabel: item.title || '',
    subHeading: item.bodyText,
  }));

export const getCardOffersContentFromPersona = (personaData) => {
  if (!personaData || Object.keys(personaData)?.length === 0) {
    return {};
  }
  const {
    iaCode,
    benefits: {
      travelBenefits: personaBenefits = {},
    } = {},
    offers: {
      carousel: offers = {},
      horizontalTiles = {},
      verticalTiles = {},
    } = {},
  } = personaData?.personas?.[0] || {};

  const concatTilesData = {
    topColumnTile: verticalTiles?.[0] || {},
    bottomColumnTile: verticalTiles?.[1] || {},
    leftRowTile: horizontalTiles?.[0] || {},
    rightRowTile: horizontalTiles?.[1] || {},
  };

  const benefits = personaBenefits && Object.keys(personaBenefits).length > 0
    ? mapPersonaBenefits(personaBenefits, iaCode)
    : [];
  const carousel = offers && Object.keys(offers).length > 0 ? mapPersonaData(offers) : [];
  const cards = mapPersonaData(concatTilesData);

  return {
    benefits, cards, carousel,
  };
};

const isRuleApplied = (ruleString, cardTypeString) => {
  const formattedRule = ruleString.toLowerCase().replace(/\s+/g, '-');
  const formattedCardTypeString = cardTypeString.toLowerCase().replace(/\s+/g, '-');
  return formattedRule === formattedCardTypeString;
};

export const getCardBasedEligibleMarketingFiles = (localePersonaMap, travelerData) => {
  if (localePersonaMap.cardIdBasedPersona) {
    return Object.keys(localePersonaMap.personas)
      .filter((marketingFileName) => {
        const marketingFileCardIdCodes = localePersonaMap.personas[marketingFileName].split(',');
        marketingFileCardIdCodes
          .forEach((marketingFileCardIdCode) => marketingFileCardIdCode.trim());
        // cardIdCode is logo code for international and IA code for US
        return localePersonaMap.personas[marketingFileName].split(',')
          .includes(travelerData.card.cardIdCode);
      });
  }
  const {
    card: {
      group: cardGroup,
      type: cardType,
      name: cardName,
    },
  } = travelerData;
  return Object.keys(localePersonaMap)
    .filter((marketingFileName) => {
      const fileRule = localePersonaMap[marketingFileName];
      const cardRule = fileRule.split(',');
      return cardRule.map((card) => {
        const [groupRule, typeRule, nameRule] = card.trim().split('-');
        if (groupRule !== '*' && !isRuleApplied(groupRule, cardGroup)) {
          return false;
        }
        if (typeRule !== '*' && !isRuleApplied(typeRule, cardType)) {
          return false;
        }
        return nameRule === '*' || isRuleApplied(nameRule, cardName);
      }).filter((value) => !!value)[0];
    });
};

export const isCardTypeEnabled = (cardType) => !!cardType.enabled;

export const validateEligibleCardOffersPath = (
  isLoggedIn,
  hasAuthLoaded,
  eligibleCardOffersOneCmsPath = ''
) => hasAuthLoaded && !!eligibleCardOffersOneCmsPath
  && !(isLoggedIn && eligibleCardOffersOneCmsPath.includes(GUEST));

export const getMarketingArticlesFromPersona = (personaData) => {
  if (!personaData || Object.keys(personaData).length === 0) {
    return { articles: [], heading: '' };
  }

  const { marketingArticles } = personaData.personas[0];
  return {
    articles: marketingArticles?.articles || [],
    heading: marketingArticles?.title || '',
  };
};

export const getExploreMoreFromPersona = (personaData) => {
  if (!personaData || Object.keys(personaData).length === 0) {
    return { articles: [], heading: '' };
  }

  const { exploreMore } = personaData.personas[0];

  return {
    articles: exploreMore?.articles || [],
    heading: exploreMore?.title || '',
  };
};
